import { call, takeLatest, put, takeEvery } from 'redux-saga/effects';
import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import SubscriptionServices from 'shared/services/SubscriptionService';
import {
  getSubscriptionData,
  setSubscriptionData,
  actionFail,
  buildSubscriptionPage,
  setIndividualSubscriptionInfo,
  createSubscription,
  createSubscriptionSuccess,
  updateSubscription,
  updateSubscriptionSuccess,
  cancelSubscription,
  cancelSubscriptionSuccess
} from './subscription.redux';
import { TAction, TPaginationRequest } from 'shared/types';

import { openNotificationMessage } from '../../shared/utils/NotificationMessages';
import { NotificationMessages } from 'shared/enums';
import { ISubscription } from 'shared/interfaces/subscription.interface';

function* getSubscription({ payload }: TAction<TPaginationRequest>) {
  try {
    const result: AxiosResponse<ISubscription[]> = yield call(
      SubscriptionServices.getSubscriptionInfo,
      payload
    );
    yield put(setSubscriptionData(result.data));
  } catch (error) {
    console.log('error', error);
  }
}

function* buildIndividualPage({ payload }: TAction<any>) {
  try {
    const result: AxiosResponse<ISubscription[]> = yield call(
      SubscriptionServices.getOneSubscription,
      payload.id
    );
    yield put(setIndividualSubscriptionInfo(result));
  } catch (error: any) {
    console.log('error', error);
    yield put(actionFail());
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message:
        error?.response?.data?.message ||
        'Something went wrong while building page.'
    });
  }
}

function* createSubscriptionSaga({ payload }: TAction<any>) {
  try {
    yield call(
      SubscriptionServices.createSubscription,
      payload.subscriptionData
    );
    yield put(createSubscriptionSuccess());
    yield openNotificationMessage({
      type: NotificationMessages.Success,
      title: 'Success',
      message: 'Subscription was successfully created.'
    });
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (error: any) {
    console.log('error', error);
    yield put(actionFail());
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message:
        error?.response?.data?.message ||
        'Subscription creation was unsuccessful.'
    });
  }
}

function* updateSubscriptionSaga({ payload }: TAction<any>) {
  try {
    yield call(
      SubscriptionServices.updateSubscription,
      payload.id,
      payload.subscriptionData
    );
    yield put(updateSubscriptionSuccess());
    yield openNotificationMessage({
      type: NotificationMessages.Success,
      title: 'Success',
      message: 'Subscription was successfully updated.'
    });
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (error: any) {
    console.log('error', error);
    yield put(actionFail());
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message:
        error?.response?.data?.message ||
        'Subscription update was unsuccessful.'
    });
  }
}

function* cancelSubscriptionSaga({ payload }: TAction<any>) {
  try {
    yield call(SubscriptionServices.cancelSubscription, payload.id);
    yield put(cancelSubscriptionSuccess());
    yield openNotificationMessage({
      type: NotificationMessages.Success,
      title: 'Success',
      message: 'Subscription was successfully cancelled.'
    });
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (error: any) {
    console.log('error', error);
    yield put(actionFail());
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message:
        error?.response?.data?.message ||
        'Subscription cancellation was unsuccessful.'
    });
  }
}

function* Subscriptions() {
  yield takeLatest(getSubscriptionData.type, getSubscription);
  yield takeLatest(buildSubscriptionPage.type, buildIndividualPage);
  yield takeEvery(createSubscription.type, createSubscriptionSaga);
  yield takeEvery(updateSubscription.type, updateSubscriptionSaga);
  yield takeEvery(cancelSubscription.type, cancelSubscriptionSaga);
}

export default Subscriptions;
